<template>
  <button
    type="button"
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-contrast-primary active:scale-95 active:bg-primary-400 md:hidden dark:bg-primary-700 dark:active:bg-primary-600 print:hidden"
    data-testid="mobile-menu-button"
    @click="open = true"
  >
    <FontAwesomeIcon :icon="['fal', 'bars']" size="lg" />
  </button>
  <TransitionRoot :show="open" as="template">
    <Dialog as="div" class="relative z-100 md:hidden" @close="open = false">
      <TransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-150 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <DialogPanel
          class="@container/menu fixed inset-0 flex h-dvh flex-col bg-gradient-to-b from-primary to-primary-700 dark:from-primary-900 dark:to-primary-700"
        >
          <div class="flex shrink-0 items-center justify-between px-5 py-3">
            <div class="flex items-center gap-2">
              <img :src="brandLogo" class="h-10" alt="logo-fm" />
              <img :src="brandText" class="h-8" alt="logo-fm" />
            </div>
            <button
              type="button"
              class="flex h-10 w-10 items-center justify-center rounded-full text-white hover:bg-black/10 active:scale-95"
              @click="open = false"
            >
              <FontAwesomeIcon :icon="['fal', 'times']" size="lg" />
            </button>
          </div>
          <nav class="min-h-0 flex-1 overflow-y-auto px-5 pb-2 text-white">
            <MainMenu expanded :only-pages="mobilePages" />
          </nav>
          <PartnerMenuLinks class="shrink-0" />
          <div
            class="shrink-0 border-t px-5 pt-4 pb-[calc(env(safe-area-inset-bottom)+1.5rem)]"
          >
            <InfoUserModalComponent expanded />
          </div>
        </DialogPanel>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import MainMenu from '@/views/layouts/main-layout/MainMenu.vue'
import InfoUserModalComponent from '@/views/layouts/top-bar/InfoUserModalComponent.vue'
import PartnerMenuLinks from '@/views/layouts/main-layout/PartnerMenuLinks.vue'
import fm_logo from '@/assets/images/funeral-manager-logo-only.svg'
import fm_text from '@/assets/images/funeral-manager-text-only.svg'
import funero_logo from '@/assets/images/funero-logo-only.svg'
import funero_text from '@/assets/images/funero-text-only.svg'

export default {
  name: 'TheMobileMenu',
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
    FontAwesomeIcon,
    MainMenu,
    PartnerMenuLinks,
    InfoUserModalComponent
  },
  data() {
    return {
      open: false,
      // On mobile the scope is the dossier: the other pages are desktop only.
      mobilePages: ['dashboard_dossier_main_page_route']
    }
  },
  computed: {
    brandLogo() {
      return this.$brand === 'funero' ? funero_logo : fm_logo
    },
    brandText() {
      return this.$brand === 'funero' ? funero_text : fm_text
    }
  },
  watch: {
    '$route.fullPath'() {
      this.open = false
    }
  }
}
</script>
